import React from "react"
import type { PesquisaSatisfacaoFornecedorActionModel } from "./pesquisaSatisfacaoFornecedorActions"
import { PesquisaSatisfacaoFornecedorInicial } from "./pesquisaSatisfacaoFornecedorReducer"
import type { PesquisaSatisfacaoFornecedorModel } from "../models/pesquisaSatisfacaoFornecedorModel"

interface PesquisaSatisfacaoFornecedorContextType {
    dados: PesquisaSatisfacaoFornecedorModel
    dispatch: React.Dispatch<PesquisaSatisfacaoFornecedorActionModel>
    pesquisar: (inicio?: number, fim?: number) => Promise<void>
    erroCarregamento: string | null
}

export const PesquisaSatisfacaoFornecedorContext =
    React.createContext<PesquisaSatisfacaoFornecedorContextType>({
        dados: PesquisaSatisfacaoFornecedorInicial,
        dispatch: () => undefined,
        pesquisar: async () => undefined,
        erroCarregamento: null,
    })
